import {Box, Tab, Tabs} from '@mui/material';
import {Route, Routes, useLocation, useNavigate} from 'react-router-dom';
import Customers from './Customers';
import {CustomerCreatePage} from './customer/CustomerCreatePage';
import {CustomerDetailCard} from './customer/CustomerDetailedCard';
import {CustomerEditPage} from './customer/CustomerEditPage';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';

function CustomersMain() {
    const navigate = useNavigate();
    const location = useLocation();
    const {t} = useAppTranslation();

    return (
        <Box>
            <Box sx={{mb: {xs: 2, md: 3}}}>
                <Tabs
                    value={location.pathname.startsWith('/app/customers') ? '/app/customers' : false}
                    onChange={(_, value: string) => navigate(value)}
                >
                    <Tab label={t('customers:customers')} value="/app/customers"/>
                </Tabs>
            </Box>

            <Routes>
                <Route index element={<Customers/>}/>
                <Route path="new" element={<CustomerCreatePage/>}/>
                <Route path=":id" element={<CustomerDetailCard/>}/>
                <Route path=":id/edit" element={<CustomerEditPage/>}/>
            </Routes>
        </Box>
    );
}

export default CustomersMain;
